/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
/**
 * Program: validation directive
 * Author: SDL
 * Description: validation directive
 */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import SDLUtil from '@/utils/SDLUtil';

const showErrMsg = (field, msg) => {
  const errDiv = document.createElement('div');

  errDiv.innerHTML = SDLUtil.getMsgProp(msg);
  errDiv.className = 'invalid-feedback';
  field.classList.add('is-invalid');
  field.insertAdjacentElement('afterend', errDiv);
};
const validationObj = (field, valids) => {
  Array.from(field.parentElement.querySelectorAll('.invalid-feedback')).forEach(el => {
    try {
      el.remove();
    } catch (e) {
      el.parentNode.removeChild(el);
    }
  });

  if (field.willValidate && !field.checkValidity()) {
    let errMsg = field.validationMessage;
    if (field.getAttribute('errorMessage')) errMsg = field.getAttribute('errorMessage');

    showErrMsg(field, errMsg);
  } else if (valids.length > 0) {
    for (let i = 0; i < valids.length; i += 1) {
      if (!valids[i].validFuncs()) {
        showErrMsg(field, valids[i].errorMessage);
        break;
      }
    }
  }
};

export default {
  bind(el, binding, vnode) {
    let groupId = '';
    let valids = [];
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
      groupId = binding.value.groupId;
    }
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'valids')) {
      valids = binding.value.valids;
    }
    SDLUtil.setValidList({ el, groupId });

    el.setAttribute('required', 'required');
    el.addEventListener('blur', e => {
      e.preventDefault();

      Array.from(document.querySelectorAll('.is-invalid')).forEach(ele => ele.classList.remove('is-invalid'));
      validationObj(el, valids);
    });
    el.addEventListener('focus', e => {
      e.preventDefault();

      el.classList.remove('is-invalid');
    });
  },
  unbind(el, binding, vnode) {
    let groupId = '';
    if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
      groupId = binding.value.groupId;
    }
    SDLUtil.deleteValidList(el, groupId);
  },
};



// WEBPACK FOOTER //
// ./src/directives/validation.js